import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody47.css';

import clientimg from '../images/case-study-client47.webp'
import outcome from '../images/outcome47.webp'

import sm1 from '../images/cs47so1.webp'
import sm2 from '../images/cs47so2.webp'
import sm3 from '../images/cs47so3.webp'
import sm4 from '../images/cs47so4.webp'


const Casestudybody47 = () => {

    return (
        <>
        <section className='casestudybody47-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A leading regional conglomerate with diversified interests across industrial & real estate, managing over USD 1Bn in assets, recognized for its commitment to operational excellence & sustainable growth</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client aimed to prepare an annual report to evaluate financial and operational performance against strategic objectives, providing the leadership team with actionable insights to guide decision-making process</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody47-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Kick-off Discussion & Objective Alignment: </h4>
                          <p>Conducted an initial session with the CEO and leadership team to <span style={{color:"#03A393",fontWeight:700}}> establish the purpose, key messaging, and strategic themes</span> of the annual report. Defined the intended audience, tone, and communication objectives to ensure alignment with the firm's vision and brand positioning</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Data Collection & Compilation:</h4>
                          <p>Coordinated with departmental heads and finance teams to collect <span style={{color:"#03A393",fontWeight:700}}> quantitative</span> (financial results, KPIs, operational metrics) and <span style={{color:"#03A393",fontWeight:700}}> qualitative data</span> (strategic initiatives, achievements, milestones) forming the foundation for MD&A and performance insights</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Compliance Review & Governance Alignment:</h4>
                          <p>Evaluated disclosures, governance statements, and statutory requirements to ensure compliance with regulatory and corporate standards. Collaborated with finance, legal, and compliance teams to validate the accuracy of audited financial statements and ensure consistency across all report sections</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Performance Analysis & Insights Generation:</h4>
                          <p>Performed a detailed review of operational and financial performance to identify <span style={{color:"#03A393",fontWeight:700}}> trends, growth drivers, and challenges.</span> Developed the <span style={{color:"#03A393",fontWeight:700}}> MD&A</span> section to articulate management's perspective on <span style={{color:"#03A393",fontWeight:700}}> results, strategic direction, and outlook,</span> aligning narratives with the company's long-term objectives</p>
                        </div>
                      </div>

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Review & Finalization:</h4>
                          <p>Facilitated iterative review with the CEO, CFO and the leadership team to <span style={{color:"#03A393",fontWeight:700}}> refine content accuracy, tone, and strategic coherence.</span> Integrated feedback to finalize the annual report, ready for board submission and external publication</p>
                        </div>
                      </div>     

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody47-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The annual report framework enabled the client to comprehensively assess organizational performance against strategic objectives, providing clear insights to support informed decision-making, strategic planning, and effective communication of results across the organization</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody47
